export const ERRORS = {
  createIssueError: 'Unable to create issue.',
  unableToLoadSelectedTemplate: 'Unable to selected template',
  unableToLoadCurrentRepository: 'Unable to load repository details.',
}
